import React from 'react'

function Service({header, description, source}) {
  return (
    <div className='service-container'>
      <h2 className='service-header'>{header}</h2>
      <div className='service-separator'></div>
      <div className='service-image-container'>
        <img src={source} alt={header} className='service-image' />
      </div>
      <p>{description}</p>
    </div>
  )
}

export default Service